import React, { useEffect, useState } from 'react'
import axios from 'axios'
// import './dashboard.css'
import './adminpanel.css'
import { Link, useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../Hooks/useAuthContext'
import { FaAlignLeft, FaSignOutAlt, FaUserAlt } from 'react-icons/fa'
import AdminSidebar from './AdminSideBar'
import Loader from '../../Component/Loader/Loader'

/* ── Stat card config ───────────────────────────────────── */
const STATS = [
  { key: 'users',    label: 'Users',            to: '/admin/users',   cls: 'activit1' },
  { key: 'deposits', label: 'Deposit Requests',  to: '/admin/deposit', cls: 'activit2' },
  { key: 'dps',      label: 'Loans',             to: '/admin/loan',    cls: 'activit3' },
  { key: 'tickets',  label: 'Tickets',           to: '/admin/tickets', cls: 'activit4' },
]

function AdminPanel() {
  const [queryData, setQueryData] = useState({
    activeLoans: null, paymentReq: null, AFD: null,
    tickets: null, deposits: null, users: null, dps: null,
  })
  const [shouldMenuSlide, setShouldMenuSlide] = useState(false)
  const [dashUser, setDashUser]               = useState(false)
  const [sidemenu, setSideMenu]               = useState(false)
  const [loading, setLoading]                 = useState(true)
  const { user, dispatch }                    = useAuthContext()
  const navigate                              = useNavigate()

  const logout = () => {
    dispatch({ type: 'LOGOUT', payload: null })
    setTimeout(() => navigate('/rf-admin'), 3000)
  }

  /* Auth guard */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/isadmin`, {
      headers: { Authorization: `Bearer ${user.token}` },
    }).then(r => {
      if (r.data.admin)      { /* ok */ }
      else if (r.data.user)  navigate('/admin-panel')
      else                   navigate('/')
    }).catch(e => console.log(e))
  }, [user.token])

  /* Data fetch */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersRes, ticketsRes, loansRes, depositsRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/users`,    { headers: { Authorization: `Bearer ${user.token}` } }),
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/tickets`,  { headers: { Authorization: `Bearer ${user.token}` } }),
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/loans`,    { headers: { Authorization: `Bearer ${user.token}` } }),
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/deposits`, { headers: { Authorization: `Bearer ${user.token}` } }),
        ])
        setQueryData({
          users:    usersRes.data.length,
          tickets:  ticketsRes.data.length,
          dps:      loansRes.data.length,
          deposits: depositsRes.data.length,
        })
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [user.token])

  return (
    <div className="admin dashboard">

      {/* ── Header ──────────────────────────────────────── */}
      <div className="dashboard-header">
        <div className="rights-side">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <p>
              {process.env.REACT_APP_APP_NAME}
              <span className="admin-badge">Admin</span>
            </p>
          </Link>
          <FaAlignLeft size={18} onClick={() => {
            setShouldMenuSlide(true)
            setSideMenu(!sidemenu)
          }} />
        </div>

        <div className="left-side">
          <div className="dh-avatar" onClick={() => setDashUser(!dashUser)}>
            <FaUserAlt size={14} />
          </div>
          {dashUser && (
            <div className="user-menu">
              <p className="logout" onClick={logout}>
                <FaSignOutAlt size={13} /> Logout
              </p>
            </div>
          )}
        </div>
      </div>

      {/* ── Sidebar — direct child of .dashboard, overlays content ── */}
      {sidemenu && (
        <AdminSidebar
          shouldMenuSlide={shouldMenuSlide}
          onClose={() => setSideMenu(false)}
        />
      )}

      {/* ── Body ─────────────────────────────────────────── */}
      <div className="dashboard-main-section">
        {loading ? (
          <Loader />
        ) : (
          <div className="main-admin-dash">
            {STATS.map(({ key, label, to, cls }) => (
              <div className={`card-body ${cls}`} key={key}>
                <p>{label}</p>
                <span>{queryData[key] ?? '—'}</span>
                <Link style={{ textDecoration: 'none', color: 'white' }} to={to}>
                  <h3>Manage →</h3>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>

    </div>
  )
}

export default AdminPanel